import { useCallback } from 'react'
import type {
  WelcomeHandoff,
  WelcomeTransitionCoordinator,
} from '@/hooks/useWelcomeTransition.types'
import { onboarding } from '@/lib/motion/presets'
import { useWelcomeTransition as useWelcomeTransitionStore } from '@/stores/welcomeTransition'

let activeHandoff: Promise<void> | null = null

function waitForRevealHold() {
  return new Promise<void>((resolve) => {
    window.setTimeout(resolve, onboarding.welcome.revealHoldMs)
  })
}

export function useWelcomeTransition(): WelcomeTransitionCoordinator {
  const run = useCallback((handoff: WelcomeHandoff) => {
    if (activeHandoff) return activeHandoff

    const transition = (async () => {
      const store = useWelcomeTransitionStore.getState()

      await store.cover()

      try {
        await handoff()
        await waitForRevealHold()
        await useWelcomeTransitionStore.getState().reveal()
      } catch (error) {
        useWelcomeTransitionStore.getState().reset()
        throw error
      }
    })()

    activeHandoff = transition

    void transition.then(
      () => {
        if (activeHandoff === transition) activeHandoff = null
      },
      () => {
        if (activeHandoff === transition) activeHandoff = null
      }
    )

    return transition
  }, [])

  return { run }
}
